import { Component, Input } from "@angular/core"
import { ErrorCode } from "../error-code.model"

@Component({
    selector: "app-unauthorized-error",
    templateUrl: "./unauthorized-error.component.html",
    styleUrls: ["./unauthorized-error.component.less"],
    host: {
        style: "flex: 1;",
    },
})
export class UnauthorizedErrorComponent {
    public image: string
    public ErrorCode = ErrorCode

    @Input()
    public nextURL: string

    @Input()
    public errorCode: ErrorCode

    @Input()
    public isStudent: boolean

    @Input()
    public errorMessage: string

    constructor() {
        this.image = require("../../../assets/Lost-in-Space.png").default
    }
}
